const ScrollDirective = {
  inserted(el, binding) {
    const loadMore = binding.value
    // let isLoading = false

    el.addEventListener('scroll', function handleScroll() {
      const { scrollTop, clientHeight, scrollHeight } = this
      const threshold = 50 // 距离底部50px触发

      if (scrollTop + clientHeight >= scrollHeight - threshold) {
        loadMore?.()
      }
    })
  },
}

export default ScrollDirective
